import React, { FC } from 'react';
import { ContentListProps, ContentListItem } from './types';
import { Typography, Image, Layout, Button, Progress, CircularProgress, IconButton } from '../';
import { List, ListItem } from '@chakra-ui/react';

export const ContentList: FC<ContentListProps> = ({ items, variant = 'default', textStyle }) => {
  return (
    <List variant="contentList" data-testid="core-content-list">
      {items?.map((item: ContentListItem, index: number) => {
        return (
          <ListItem key={item.key || `${item.heading}-${index}`} py="md">
            <Layout
              variant="grid"
              gap="xs"
              gridTemplateColumns={['1fr', null, 'auto 1fr', null, null]}
              alignItems={['start', null, 'center', 'center', null]}
            >
              <Layout borderRadius="8px" overflow="hidden" maxWidth={['auto', null, 200, null, null]}>
                {variant === 'withCircularProgress' ? (
                  item.progress !== undefined && (
                    <CircularProgress
                      value={item.progress}
                      shapeSize={'20px'}
                      thickness={'17px'}
                      colorScheme={item.colorScheme}
                    />
                  )
                ) : (
                  <Image path={item.image || ''} />
                )}
              </Layout>
              <Layout
                variant="grid"
                gridTemplateColumns={
                  variant === 'withCircularProgress'
                    ? ['1fr auto', '1fr auto', '1fr auto', '1fr auto', null]
                    : ['1fr', '1fr', '1fr', '1fr auto', null]
                }
                alignItems="center"
                gap={4}
              >
                <Layout>
                  <Typography variant="p4" fontSize="12px" letterSpacing="0.75px" textTransform="uppercase">
                    {item.label}
                  </Typography>
                  <Typography variant={textStyle}> {item.heading}</Typography>
                  {item.progress !== undefined && <Typography variant="p1"> {item.description}</Typography>}
                </Layout>
                <Layout
                  variant="grid"
                  gridTemplateColumns={['1fr', null, '1fr auto', null, null]}
                  alignItems="center"
                  columnGap={4}
                >
                  {variant !== 'withCircularProgress' && item.progress !== undefined && (
                    <Layout width={['auto', null, null, 32, '2xs']} pt={2}>
                      <Progress labelPosition="bottom" value={item.progress} />
                    </Layout>
                  )}
                  {item.children}
                  {item.button && (
                    <Layout alignSelf="center">
                      {item.hasIconButton ? (
                        <IconButton
                          icon={{ iconName: 'chevron-right' }}
                          variant={'tertiary'}
                          isRound
                          {...item.button}
                        />
                      ) : (
                        <Button {...item.button} />
                      )}
                    </Layout>
                  )}
                </Layout>
              </Layout>
            </Layout>
          </ListItem>
        );
      })}
    </List>
  );
};
